// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__su1Fv","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__Utu5K"};